import { createTheme } from "@mui/material/styles";
import type { BrandTokens } from "../types";

export const createCleanTheme = (brand: BrandTokens) =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: brand.primary },
      secondary: { main: brand.secondary },
      warning: { main: brand.accent },
      background: { default: "#f5f6f8", paper: "#ffffff" },
      text: { primary: brand.text, secondary: "rgba(11, 31, 39, 0.65)" }
    },
    shape: { borderRadius: brand.radius + 4 },
    typography: {
      fontFamily: brand.fontFamily,
      h1: { fontWeight: 600, letterSpacing: "-0.02em", fontSize: "clamp(2.2rem, 3.6vw, 3.1rem)" },
      h2: { fontWeight: 600, fontSize: "clamp(1.7rem, 2.6vw, 2.2rem)" },
      h3: { fontWeight: 600, fontSize: "clamp(1.3rem, 2vw, 1.7rem)" },
      body1: { fontSize: "1rem", lineHeight: 1.7 },
      body2: { fontSize: "0.95rem", lineHeight: 1.7 },
      button: { textTransform: "none", fontWeight: 600 }
    },
    components: {
      MuiAppBar: {
        defaultProps: { color: "transparent", elevation: 0 }
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } }
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: brand.radius + 4, padding: "10px 22px" }
        }
      }
    }
  });
